import { SlideshowContent, Slide } from '../types/Slideshow';


export function getSlideshow(): SlideshowContent {
  const slides: Slide[] = [];

  const $ = (window as any).jQuery;
  const totalSlides = Number($('.slideshow-info').attr('slideshow-page-num-max'));
  const afterSlideshowEnd = $('#after-slideshow-end');

  var slideshowTitle = '';
  var landingImageElement;
  var landingDescription = '';

  var isLastSlide = false;
  var index = 0;
  do {
    var title;
    var content;
    var image;

    isLastSlide = index >= totalSlides + 1;

    if (index === 0) {
      slideshowTitle = $('head > title').text();
      landingDescription = $('.article-content .slideshow-start').html() || '';
      landingImageElement = $(`[type='image'][slideshow-page-num='start']`).html() || '';

    } else {
      if (isLastSlide) {
        title = $('head > title').text();
        content = $('.article-content .slideshow-end').html() || '';
        if (afterSlideshowEnd) {
          content += afterSlideshowEnd.html() || '';
        }
        image = $(`[type='image'][slideshow-page-num='start']`).html() || '';
        if (image.length === 0) {
          image = $(`[type='image'][slideshow-page-num=1]`);
        }
      } else {
        title = $(`[type='header'][slideshow-page-num=${index}]`).text();
        content = $(`[type='desc'][slideshow-page-num=${index}]`).html() || '';
        image = $(`[type='image'][slideshow-page-num=${index}]`).html() || '';
      }

      slides.push({
        number: index,
        title,
        description: content,
        imageElement: image,
        isLastSlide
      });
    }

    index += 1;
  } while (!isLastSlide);

  $('.slideshow-part').remove();

  return {
    title: slideshowTitle,
    aboutThisSlideshow: '',
    aboutUs: '',
    landingImageElement,
    landingDescription,
    slides
  }
}

export const otherSlideshowSlugs = [];
